import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioSnrs2 } from './pages'

type TIdToPageMapStylioSnrs2 = Record<PageIdStylioSnrs2, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_SNRS2: TIdToPageMapStylioSnrs2 = {
  [PageIdStylioSnrs2.AGE_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/AgeQuestion'),
  },
  [PageIdStylioSnrs2.URGE_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePage'),
  },
  [PageIdStylioSnrs2.HAIR_COLOR_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioSnrs2.EYES_COLOR_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioSnrs2.JEWELRY_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/JewelryQuestion').then(
        (m) => ({
          default: m.JewelryQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioSnrs2.BODY_SHAPE_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioSnrs2.STYLIO_TO_HELP_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/StylioToHelp'),
  },
  [PageIdStylioSnrs2.TALL_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/TallQuestion'),
  },
  [PageIdStylioSnrs2.WEIGHT_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/WeightQuestion').then(
        (m) => ({
          default: m.WeightQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/WeightQuestion'),
  },
  [PageIdStylioSnrs2.URGE_2_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioSnrs2.SHOPPING_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioSnrs2.STYLE_MOST_MATTERS_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioSnrs2.FAVORITE_COLORS_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/FavoriteColorsQuestion'
      ),
  },
  // [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2]: {
  //   Component: lazy(() =>
  //     import(
  //       'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeSnrs'
  //     ).then((m) => ({
  //       default: m.LikeOrDislikeSnrs,
  //     })),
  //   ),
  //   preload: () =>
  //     import(
  //       'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeSnrs'
  //     ),
  // },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_1]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant1Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant1Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant1Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant2Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant2Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant2Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant3Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant3Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant3Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_4]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant4Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant4Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant4Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_5]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant5Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant5Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant5Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_6]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant6Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant6Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant6Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_7]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant7Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant7Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant7Snrs'
      ),
  },
  [PageIdStylioSnrs2.LIKE_OR_DISLIKE_SNRS2_8]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant8Snrs'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant8Snrs,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/likeOrDislike/LikeOrDislikeVariant8Snrs'
      ),
  },
  [PageIdStylioSnrs2.STYLES_FEEL_LIKE_YOU_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/StylesFeelLikeYou'
      ).then((m) => ({
        default: m.StylesFeelLikeYou,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/StylesFeelLikeYou'),
  },
  [PageIdStylioSnrs2.URGE_4_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioSnrs2.BRAND_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/BrandQuestion'),
  },
  [PageIdStylioSnrs2.FIND_NEW_CLOTHES_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioSnrs2.NOTHING_TO_WEAR_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioSnrs2.OLD_CLOTHES_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioSnrs2.COMBINE_CLOTHES_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioSnrs2.OUTFIT_LOOK_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/OutfitLook').then(
        (m) => ({
          default: m.OutfitLook,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/OutfitLook'),
  },
  [PageIdStylioSnrs2.OPTIMIZE_BUDGET_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioSnrs2.EVERYDAY_LIFESTYLE_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/questions/EverydayLifestyle'
      ).then((m) => ({
        default: m.EverydayLifestyle,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/EverydayLifestyle'),
  },
  [PageIdStylioSnrs2.CLIMAT_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/ClimatQuestion').then(
        (m) => ({
          default: m.ClimatQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioSnrs2.URGE_3_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioSnrs2.PREPARE_FLOW_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioSnrs2.EMAIL_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs2/pages/email/Email'),
  },
  [PageIdStylioSnrs2.SUBSCRIPTIONS_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioSnrs2.CANCEL_OFFER_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/cancel-offer/CancelOffer').then(
        (m) => ({
          default: m.CancelOffer,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioSnrs2.SUB_UPSELL_SNRS2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioSnrs2.UPSELL_SNRS_2]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs2/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs2/pages/upsell/Upsell'),
  },
  [PageIdStylioSnrs2.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioSnrs2.DOWNLOAD_SNRS2]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs2/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs2/pages/download-app/DownloadDefault'),
  },
}
